import React from "react";
import { Reveal } from "@/components/motion/Reveal";
import { ASSETS } from "@/data/content";
import { useI18n } from "@/i18n";
import { openBookingModal } from "@/components/BookingModal";

export default function Story() {
  const { t } = useI18n();
  const s = t.story;
  return (
    <section
      id="miejsce"
      data-testid="story-section"
      className="relative bg-canvas-surface py-14 md:py-20 lg:py-28 overflow-hidden"
    >
      {/* Decorative sun — sparing accent */}
      <div
        className="sun-motif w-[420px] h-[420px] -top-24 -left-24 opacity-60 hidden md:block"
        aria-hidden="true"
      />

      {/* Large logo watermark emerging from the left */}
      <img
        src={ASSETS.logo}
        alt=""
        aria-hidden="true"
        data-testid="story-watermark"
        className="pointer-events-none select-none absolute top-1/2 -translate-y-1/2 -left-40 md:-left-56 w-[460px] md:w-[680px] opacity-[0.07] grayscale hidden md:block"
      />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center relative">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="overline mb-8">{s.overline}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-ink">
              {s.headingA}<br />
              <span className="italic text-brand-red/90">{s.headingB}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-10 text-ink-muted text-base md:text-lg leading-relaxed max-w-md space-y-5">
              <p>
                {s.p1a}
                <br />
                {s.p1b}
              </p>
              <p>
                {s.p2}
              </p>
              <p className="serif italic text-xl md:text-2xl text-brand-red/90 leading-snug pt-2">
                {s.quote}
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <div className="relative overflow-hidden">
              <img
                src={ASSETS.storyCabin}
                alt={s.cabinAlt}
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-ink/10 pointer-events-none" />
            </div>
          </Reveal>
        </div>
      </div>

      <Reveal className="relative mt-14 md:mt-16 flex justify-center">
        <button
          type="button"
          onClick={openBookingModal}
          data-testid="hero-reserve-btn"
          className="btn-accent"
        >
          {s.cta}
        </button>
      </Reveal>
    </section>
  );
}
